// extracted by mini-css-extract-plugin
export var footer = "_po-0";
export var inherit = "_po-1";
export var input = "_po-2";
export var modalContent = "_po-3";
export var quillEditor = "_po-4";
export var subtitle = "_po-5";